import React from 'react';
import { Button } from '../Button/Button';
import './MultiSelect.css';

interface MultiSelectProps {
  options: Array<{ value: string; label: string }>;
  selected: string[];
  onChange: (selected: string[]) => void;
  error?: string;
}

export const MultiSelect: React.FC<MultiSelectProps> = ({
  options,
  selected,
  onChange,
  error
}) => {
  const toggleOption = (value: string) => {
    if (selected.includes(value)) {
      onChange(selected.filter(v => v !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  return (
    <div className="multi-select">
      <div className="multi-select__options">
        {options.map((option) => (
          <Button
            key={option.value}
            variant="outline"
            size="large"
            fullWidth
            selected={selected.includes(option.value)}
            onClick={() => toggleOption(option.value)}
          >
            {option.label}
          </Button>
        ))}
      </div>
      
      {error && (
        <div className="multi-select__error">
          {error}
        </div>
      )}
    </div>
  );
};
